import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgCardTypeFile = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		d: "m22 11.4-8.8 8.8c-2.5 2.5-6.7 2.5-9.2 0h0c-2.5-2.5-2.5-6.7 0-9.2l7.8-7.8c1.8-1.8 4.6-1.8 6.4 0h0C20 5 20 7.8 18.2 9.6L11 16.7c-1 1-2.6 1-3.5 0h0c-1-1-1-2.6 0-3.5l6-6"
	})
});
export default SvgKgCardTypeFile;
